import { HttpUtil } from "../../utils/http-utils";
import {
  SHOW_SNACKBAR,
  IS_LOADING,
} from "../../utils/types";
const getApiLoaderDispatch = (res, dispatch) => {
  dispatch({ type: IS_LOADING, payload: { type: IS_LOADING, payload: res } });
};

function postAction(dispatch, url, isApiLoader, request, header, action) {
  if (isApiLoader) {
    getApiLoaderDispatch(isApiLoader, dispatch);
  }
  return HttpUtil.makePOST(url, request, header)
    .then((res) => {
      if (res?.status === 200) {
        action(res?.data);
      } else {
        dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: res?.data?.description ?? "Some Error Occurred", open: true } });
      }
      if (isApiLoader) {
        getApiLoaderDispatch(false, dispatch);
      }
    })
    .catch(() => {
      getApiLoaderDispatch(false, dispatch);
      dispatch({ type: SHOW_SNACKBAR, payload: { type: "#104d89", message: "Please contact with administrator", open: true } });
    });
}

function postParamsAction(dispatch, url, isApiLoader, request, Params, header, action) {
  if (isApiLoader) {
    getApiLoaderDispatch(isApiLoader, dispatch);
  }
  return HttpUtil.makePOSTwithParams(url, request, Params, header)
    .then((res) => {
      if (res?.status === 200) {
        action(res?.data);
      } else {
        getApiLoaderDispatch(false, dispatch);
        dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: res?.data?.description ? res?.data?.description : res?.data?.message ? res?.data?.message : "Some Error Occurred", open: true } });
      }
      if (isApiLoader) {
        getApiLoaderDispatch(false, dispatch);
      }
    })
    .catch(() => {
      getApiLoaderDispatch(false, dispatch);
      dispatch({ type: SHOW_SNACKBAR, payload: { type: "#104d89", message: "Please contact with administrator", open: true } });
    });
}

function getAction(dispatch, url, isApiLoader, request, header, action) {
  if (isApiLoader) {
    getApiLoaderDispatch(isApiLoader, dispatch);
  }
  return HttpUtil.makeGET(url, request, header)
    .then((res) => {
      if (res?.status === 200) {
        action(res?.data);
      } else {
        dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: res?.data?.description ? res?.data?.description : res?.data?.message ? res?.data?.message : "Some Error Occurred", open: true } });
      }
      if (isApiLoader) {
        getApiLoaderDispatch(false, dispatch);
      }
    })
    .catch(() => {
      getApiLoaderDispatch(false, dispatch);
      dispatch({ type: SHOW_SNACKBAR, payload: { type: "#104d89", message: "Please contact with administrator", open: true } });
    });
}

//loging
export const getUUid = (request, action) => (dispatch) => getAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/authorize`, false, request, {}, action);
export const sendOTP = (request, params, action) => (dispatch) => postParamsAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/otp`, true, request, params, {}, action);
export const verifyUser = (request, params, loginType, action) => (dispatch) => postParamsAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/login/${loginType}`, false, request, params, {}, action);
export const generateToken = (request, params, action, header = {}) => (dispatch) => postParamsAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/token`, false, request, params, header, action);
export const getForgotLink = (request, clientId, action) => (dispatch) => postAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/get-forgot-link/${clientId}`, true, request, {}, action);
export const forgotPassword = (request, code, action) => (dispatch) => postAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/forgot-password/${code}`, true, request, {}, action);
export const validateForgotLink = (code, action) => (dispatch) => getAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/validate-forgot-link/${code}`, false, {}, {}, action);
export const forgotUsername = (request, clientId, action) => (dispatch) => postAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/forgot-username/${clientId}`, true, request, {}, action);
export const getUnblockAccountLink = (request, clientId, action) => (dispatch) => postAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/unblock-account-link/${clientId}`, true, request, {}, action);
export const unblockAccount = (request, code, action) => (dispatch) => postAction(dispatch, `${process.env.REACT_APP_PRODUCT_APIURL}/oauth2/unblock-account/${code}`, false, request, {}, action);

// Signup and Onboarding
